module.exports = __webpack_public_path__ + "4bdf4e238f9abaa42c955fa0b4eb53f1.jpg";